<template>
	<div class="about">
		<top-nav :img-list="banner" class="top-nav"  isParent>
			<div class="banner-item-title" style="color: #333;" v-html="static.banner.title"></div>
			<div class="banner-item-title" style="color: #333;font-size: 82px;text-align: center;margin-top: 10px;"
				v-html="static.banner.title2"></div>
		</top-nav>
		<div class="block-area  pb-80px">
			<div class="block-content">
				<!-- <div class="link-card">
					<div class="lc-item" v-for="(t, i) in block1" @click="scrollTo(i)" :class="{ checked: !i }" :key="i"
						@mouseenter="hi = i" @mouseleave="hi = -1">
						<img :src="hi === i || !i ? t.hoverIcon : t.icon" alt="">
						<div class="lc-title">{{ t.title }}</div>
					</div>
				</div> -->
				<block-title ref="b1" style="margin-top: 80px;" :data="static.title1"></block-title>
				<div class="v-list" style="margin-top: 80px;">
					<div class="v-item" v-for="(t, i) in block2">
						<div class="sp-icon">
							<div v-html="t.svg"></div>
						</div>
						<div class="sp-tt">{{ t.title }}</div>
						<div class="sp-sub">{{ t.sub.toUpperCase() }}</div>
						<div class="sp-description">{{ t.description }}</div>
					</div>
				</div>
			</div>
		</div>

		<div class="block-area relative bbg pt-80px pb-40px" ref="b2">
			<div class="block-content">
				<div class="bt">
					<div class="title">{{ static.p1.title }}</div>
					<div class="en" style="margin-top: 10px;">{{ static.p1.en.toUpperCase() }}</div>
					<div class="sub" style="margin-top: 20px;">{{ static.p1.sub }}</div>
				</div>
				<div class="tips">
					<div>
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;四川华航智飞科技有限公司是一家在无人机领域迅速崛起的高科技企业。公司坐落于四川省成都市天府新区，这里汇聚了一批充满激情与创造力的专业人才。
					</div>
					<div>
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在技术研发方面，公司拥有一支由资深工程师、软件开发者和航空专家组成的强大团队。他们致力于不断突破无人机技术的边界，在飞行稳定性、续航能力、图像传输质量等关键领域取得了卓越成就。通过持续的创新投入，公司掌握了多项核心技术专利，确保了产品在市场上的竞争优势。
					</div>
					<div>
						公司的产品线丰富多样，涵盖了消费级、专业级和工业级无人机。消费级无人机以其便携性、易操作性和出色的拍摄性能，深受摄影爱好者和普通消费者的喜爱。专业级无人机则为影视制作、新闻报道、体育赛事等领域提供了高质量的航拍解决方案，其精准的操控和高分辨率的图像输出，为专业用户带来了全新的创作体验。工业级无人机更是在农业植保、电力巡检、地理测绘、环境监测等领域发挥着重要作用，极大地提高了工作效率和安全性。
					</div>
					<div>
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在生产制造环节，公司严格遵循国际质量标准，采用先进的生产工艺和设备，确保每一架无人机都具备卓越的品质和可靠性。从原材料的选择到成品的检测，每一个步骤都经过严格把关，为用户提供放心的产品。
						此外，公司还非常重视客户服务。拥有一支专业的售后团队，随时为用户提供技术支持和维修服务。无论是产品使用中的问题解答，还是故障排除，都能及时响应，确保用户的使用体验。
					</div>
					<div>
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;展望未来，四川华航智飞科技有限公司将继续秉持创新、品质、服务的理念，不断推出更先进、更智能的无人机产品，为推动无人机行业的发展做出更大的贡献。同时，公司也将积极拓展国际市场，让世界见证中国无人机技术的强大实力。
					</div>
				</div>
				<!-- <div class="my-box" >
					<div class="my-list">
						<div class="my-item"><img src="../asset//about/my-1.png"/></div>
						<div class="my-item" style="margin-left: 24px;margin-right: 24px;"><img src="../asset//about/my-2.png"/></div>
						<div class="my-item"><img src="../asset//about/my-3.png"/></div>
					</div>
				</div> -->
				<!-- <div class="zig-card" style="margin-top: 40px;">
					<img src="@/asset/about/b3-0.png" alt="">
					<div class="word-context">
						<div class="wt">{{ static.p1.word }}</div>
						<div class="word" v-html="static.p1.description"></div>
					</div>
				</div> -->
			</div>
		</div>

		<div class="team">
      <block-title
        :title="static.team.top.title"
        :en="static.team.top.en"
        :sub="static.team.top.sub"
      ></block-title>
      <div class="team-content">
        <div class="left">
          <div class="brief">
            {{ static.team.left.brief }}
          </div>
        </div>
        <div class="right">
          <div class="item" v-for="(t, index) of static.team.right" :key="index">
            <div class="label">
							<span>{{ t.label }}</span>
							<span>{{ t.value }}</span>
						</div>
          </div>
        </div>
      </div>
    </div>

		<div class="block-area pt-80px pb-80px" ref="b5">
			<div class="block-content">
				<block-title :data="static.title4"></block-title>
				<div class="block-info" style="margin-top: 80px;">
					<div class="title" style="font-weight: 800;">{{ static.p3[0] }}</div>
					<div class="if-list">
						<div class="if-item">
							<div class="if-tt">全国服务热线：</div>
							<div class="if-val" style="white-space: nowrap">
								<span>{{ static.p3[1] }}</span>
								<span class="sm">{{ static.p3[2] }}</span>
							</div>
						</div>
						<div class="if-item">
							<div class="if-tt">电子邮箱：</div>
							<div class="if-val">
								<span>{{ static.p3[3] }}</span>
							</div>
						</div>
						<div class="if-item">
							<div class="if-tt">联系地址：</div>
							<div class="if-val" style="font-size: 16px">
								<span>{{ static.p3[4] }}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="map-container"></div>
				<!-- <div class="sub-container" style="margin-top: 40px;">
					<n-select placeholder="请选择您需要的方案所属行业" :options="options" @change="i => index = i"></n-select>
					<div class="n-i required">
						<input type="text" placeholder="姓名" v-model="form.name">
					</div>
					<div class="n-i required">
						<input type="text" placeholder="手机号码" v-model="form.phone">
					</div>
					<div class="n-i">
						<input type="text" placeholder="公司名称" v-model="form.company">
					</div>
					<div class="n-btn" @click="sendInfo"><span>提交</span></div>
				</div> -->
			</div>
		</div>
		<my-footer></my-footer>
	</div>
</template>

<script>
import banner from "../asset/about/bg.png";
import { mapGetters } from "vuex";
import NSelect from "../components/n-select/n-select.vue";

export default {
	components: { NSelect },
	data() {
		return {
			hi: -1,
			defines: {
				block1: [
					{
						title: '核心价值',
						icon: require('@/asset/about/b-1.webp'),
						hoverIcon: require('@/asset/about/b-1-hover.webp')
					},
					{
						title: '公司简介',
						icon: require('@/asset/about/b-2.webp'),
						hoverIcon: require('@/asset/about/b-2-hover.webp')
					},
					{
						title: '荣誉资质',
						icon: require('@/asset/about/b-3.webp'),
						hoverIcon: require('@/asset/about/b-3-hover.webp')
					},
					{
						title: '技术合作',
						icon: require('@/asset/about/b-4.webp'),
						hoverIcon: require('@/asset/about/b-4-hover.webp')
					},
					{
						title: '联系我们',
						icon: require('@/asset/about/b-5.webp'),
						hoverIcon: require('@/asset/about/b-5-hover.webp')
					},
				],
				block2: [
					{
						"title": "核心技术优势",
						"sub": "CORE TECHNOLOGICAL ADVANTAGES",
						"description": "四川华航智飞科技有限公司拥有一支由资深无人机专家、软件工程师、创意设计师及项目管理人才组成的精英团队。公司自主研发了先进的无人机编队飞行控制系统、高精度定位算法以及智能调度平台，确保每一场无人机表演都能实现精准定位、灵活编队、安全飞行。同时，公司不断探索无人机技术的边界，将人工智能、大数据、云计算等前沿技术融入表演中，为观众带来前所未有的观赏体验。",
						"svg": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"36\" height=\"36\" viewBox=\"0 0 36 36\"><defs><clipPath id=\"master_svg0_329_43656\"><rect x=\"0\" y=\"0\" width=\"36\" height=\"36\" rx=\"0\"/></clipPath></defs><g clip-path=\"url(#master_svg0_329_43656)\"><g><path d=\"M4.5,4.125L31.5,4.125C32.9497,4.125000343323,34.125,5.30025,34.125,6.75L34.125,24.75C34.125,26.1997,32.9497,27.375,31.5,27.375L4.5,27.375C3.05025,27.375,1.875000171661,26.1997,1.875,24.75L1.875,6.75C1.875,5.30025,3.05025,4.125000343323,4.5,4.125ZM31.5,25.125C31.7071,25.125,31.875,24.9571,31.875,24.75L31.875,6.75C31.875,6.54289,31.7071,6.375,31.5,6.375L4.5,6.375C4.29289,6.375,4.125,6.54289,4.125,6.75L4.125,24.75C4.125,24.9571,4.29289,25.125,4.5,25.125L31.5,25.125Z\" fill=\"currentColor\" fill-opacity=\"1\"/></g><g><path d=\"M12.7041796875,22.1707236328125L6.6591796875,16.124973632812498L12.7049296875,10.0792236328125L14.2956796875,11.6699736328125L9.8406796875,16.124973632812498L14.2949296875,20.5792236328125L12.7041796875,22.1707236328125Z\" fill=\"currentColor\" fill-opacity=\"1\"/></g><g><path d=\"M23.295828125,22.1706560546875L21.70507949829,20.5799560546875L26.159328125000002,16.1249560546875L21.705078125,11.6707060546875L23.295828125,10.0799560546875L29.340828125,16.1249560546875L23.295828125,22.1706560546875Z\" fill=\"currentColor\" fill-opacity=\"1\"/></g><g><path d=\"M25.875,31.875L10.875,31.875L10.875,29.625L25.875,29.625L25.875,31.875Z\" fill=\"currentColor\" fill-opacity=\"1\"/></g></g></svg>"
					},
					{
						"title": "业务范围",
						"sub": " BUSINESS SCOPE",
						"description": "公司核心业务涵盖无人机表演策划与执行、空域媒体广告发布、品牌活动创意定制等。无论是大型庆典、体育赛事、音乐节、开幕式，还是企业发布会、产品推广等场合，四川华航智飞都能根据客户需求，量身定制专属的无人机表演方案，通过璀璨的灯光、多变的图案、动态的文字与视频等元素，在空中绘制出令人叹为观止的视觉艺术作品，有效提升品牌形象，增强活动影响力。",
						"svg":"<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"36\" height=\"36\" viewBox=\"0 0 36 36\"><defs><clipPath id=\"master_svg0_329_43672\"><rect x=\"0\" y=\"0\" width=\"36\" height=\"36\" rx=\"0\"/></clipPath></defs><g clip-path=\"url(#master_svg0_329_43672)\"><g><path d=\"M18.0104,34L7.86878,34C7.68232,34,7.49586,34,7.31457,33.9737C6.96754,33.9212,6.6205099999999995,33.8634,6.28902,33.7425C5.9602699999999995,33.625299999999996,5.64436,33.4739,5.34634,33.2906C4.9268,33.0279,4.54869,32.7179,4.22756,32.3343C3.623713,31.6247,3.216212,30.7652,3.046616,29.8437C3.0155387,29.665,3,29.4864,3,29.3077L3,8.841380000000001C3,8.52085,3.0517956,8.210840000000001,3.129489,7.90082C3.274517,7.31757,3.512776,6.78161,3.839088,6.28243C4.04627,5.9619,4.28453,5.66765,4.56423,5.41018C4.875,5.1264400000000006,5.2064900000000005,4.8794699999999995,5.57424,4.6798C5.9886,4.453860000000001,6.423690000000001,4.30148,6.8794900000000005,4.201639999999999C7.24206,4.12282,7.60463,4.10181,7.9672,4.10181L10.9558,4.10181C11.09565,4.10181,11.10601,4.0913,11.1578,3.95993C11.28729,3.62365,11.46858,3.31363,11.70166,3.04039C11.96842,2.735198,12.29239,2.486916,12.6547,2.310016C12.92403,2.178654,13.2037,2.10509,13.4938,2.0472906C13.6751,2.010509,13.8615,2,14.0428,2L22.0193,2C22.4233,2,22.817,2.0735632,23.1951,2.225944C23.5939,2.38358,23.9513,2.625287,24.2465,2.9458130000000002C24.5211,3.2400700000000002,24.7282,3.5763499999999997,24.8681,3.9546799999999998C24.9199,4.086040000000001,24.9303,4.096550000000001,25.0701,4.096550000000001L28.1623,4.096550000000001C28.7061,4.096550000000001,29.2293,4.201639999999999,29.7369,4.38555C30.0632,4.50115,30.374,4.65353,30.664,4.84269C31.068,5.1054200000000005,31.441,5.41544,31.7517,5.7885100000000005C32.3408,6.4918,32.7374,7.33984,32.9016,8.247620000000001C32.968900000000005,8.60493,33,8.96749,33,9.33005L33,28.9084C33,29.355,32.9637,29.8016,32.855000000000004,30.2378C32.726,30.781,32.5071,31.298,32.207499999999996,31.7668C31.9848,32.1189,31.7258,32.4447,31.4151,32.7232C31.2234,32.8965,31.0214,33.0542,30.809,33.1961C30.5086,33.395700000000005,30.1875,33.553399999999996,29.8508,33.6847C29.5452,33.8056,29.2241,33.8686,28.903,33.9317C28.6129,33.9895,28.3177,33.9895,28.0224,33.9895L17.994799999999998,33.9895L18.0104,34ZM17.9845,31.8877L28.183,31.8877C28.5249,31.8877,28.8512,31.8194,29.1723,31.6985C29.2448,31.6722,29.3173,31.6407,29.3847,31.6039C29.7058,31.4305,29.9855,31.1993,30.2289,30.9209C30.3636,30.7685,30.4827,30.6003,30.5811,30.4217C30.8349,29.9593,30.9489,29.4601,30.9489,28.9294L30.9489,9.26699L30.9489,9.146139999999999C30.9437,8.862400000000001,30.9023,8.58916,30.8194,8.31593C30.7003,7.94286,30.5138,7.60657,30.2652,7.30181C29.9855,6.97077,29.6592,6.70279,29.2707,6.51888C28.9496,6.37176,28.6129,6.28768,28.2607,6.28768L25.0494,6.28768C24.9665,6.28768,24.9251,6.32447,24.894,6.38752L24.8474,6.49787C24.6843,6.89096,24.4447,7.24661,24.143,7.54351C23.7907,7.88506,23.3764,8.12676,22.9102,8.268640000000001C22.6512,8.34745,22.3819,8.38424,22.1126,8.38424L13.934,8.38424C13.7735,8.38424,13.6129,8.36847,13.4575,8.3422C13.0846,8.2844,12.74275,8.147780000000001,12.41644,7.95337C12.22997,7.84302,12.06423,7.71166,11.90366,7.56453C11.81765,7.48524,11.73798,7.39914,11.6654,7.30706C11.45304,7.03908,11.28211,6.75008,11.16298,6.43481C11.12673,6.33498,11.07493,6.29294,10.9558,6.29294L7.92576,6.29294C7.69786,6.29294,7.46996,6.29819,7.24724,6.34548C7.04006,6.39278,6.83287,6.44532,6.64123,6.5399C6.30974,6.70279,6.02486,6.91823,5.77624,7.19672C5.62604,7.36486,5.49137,7.53826,5.387779999999999,7.73793C5.13916,8.195070000000001,5.0252099999999995,8.689,5.0252099999999995,9.2092L5.0252099999999995,28.9819C5.0252099999999995,29.1238,5.03557,29.2709,5.0511099999999995,29.4128C5.11844,29.933,5.32044,30.3954,5.64157,30.8053C5.79696,30.9997,5.967890000000001,31.1731,6.15953,31.3307C6.48584,31.5987,6.8535900000000005,31.7616,7.2576,31.8509C7.42852,31.8877,7.60463,31.8982,7.77555,31.8982L17.994799999999998,31.8982L17.9845,31.8877ZM18.0259,4.201639999999999L13.8978,4.201639999999999C13.5404,4.201639999999999,13.297,4.3803,13.1105,4.66929C12.99137,4.8532,12.97583,5.06338,12.97583,5.27882C12.97583,5.7202,13.4213,6.20361,13.903,6.19836C16.643,6.18785,19.3829,6.19836,22.1229,6.19836C22.3198,6.19836,22.501,6.15107,22.6564,6.0197C22.8118,5.8936,22.9361,5.741210000000001,23.0035,5.5520499999999995C23.0501,5.41544,23.0552,5.27882,23.0501,5.136950000000001C23.0345,4.74286,22.8325,4.46962,22.501,4.28571C22.3819,4.21741,22.2472,4.2069,22.1074,4.2069L18.0259,4.2069L18.0259,4.201639999999999Z\" fill=\"currentColor\" fill-opacity=\"1\"/></g><g><path d=\"M17.9988,15L24.7528,15C24.8753,15,24.997799999999998,15.0053286,25.1147,15.0373002C25.588,15.154529,25.9053,15.522202,25.9777,15.98579C26.0223,16.24689,25.9388,16.48135,25.794,16.694490000000002C25.5768,17.01954,25.2483,17.18472,24.8474,17.2167C24.775,17.22202,24.7027,17.22202,24.6303,17.22202L11.27824,17.22202C11.17802,17.22202,11.0778,17.22202,10.983141,17.20604C10.73815,17.17407,10.526566,17.0675,10.359527,16.90231C10.0699913,16.61989,9.88068,16.16696,10.0866953,15.714032C10.264871,15.325044,10.554406,15.0852575,10.994277,15.0106572C11.0778,15,11.16132,15,11.24484,15L17.9988,15ZM17.9654,23.99467L11.27268,23.99467C11.17245,23.99467,11.06666,23.99467,10.966436999999999,23.97869C10.727014,23.94671,10.520998,23.834809999999997,10.359527,23.67496C10.0699913,23.381880000000002,9.886248,22.939610000000002,10.0978313,22.48668C10.276007,22.09236,10.576678,21.8579,11.02212,21.78863C11.07223,21.7833,11.12234,21.77798,11.17245,21.77798L24.8363,21.77798C25.1648,21.77798,25.443199999999997,21.90053,25.6659,22.11901C25.877499999999998,22.326819999999998,25.9944,22.58792,26,22.88099C26,23.088810000000002,25.9332,23.28597,25.8163,23.46181C25.5991,23.78686,25.2762,23.957369999999997,24.8753,23.99467C24.7917,24,24.708199999999998,24,24.6247,24L17.97653,24L17.9654,23.99467Z\" fill=\"currentColor\" fill-opacity=\"1\"/></g></g></svg>"
					},
					{
						"title": "市场影响力",
						"sub": "MARKET INFLUENCE",
						"description": "自成立以来，四川华航智飞科技有限公司已成功为众多国内外知名企业和品牌提供了高质量的无人机表演服务，赢得了客户的高度认可和广泛赞誉。公司凭借其卓越的技术实力、丰富的项目经验和创新的思维模式，在无人机表演行业树立了良好的口碑，成为推动行业发展的重要力量。",
						"svg": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"36\" height=\"36\" viewBox=\"0 0 36 36\"><defs><clipPath id=\"master_svg0_329_43679\"><rect x=\"0\" y=\"0\" width=\"36\" height=\"36\" rx=\"0\"/></clipPath></defs><g clip-path=\"url(#master_svg0_329_43679)\"><g><path d=\"M3.6674654374999998,16.4699337890625L3.8024684375,16.4699337890625C4.2839684375000004,16.4690337890625,4.6915284375,16.1142337890625,4.7587184375,15.6374337890625C5.6392084375,9.6548337890625,10.3402284375,4.9583837890625,16.3236984375,4.0837137890625C16.8666984375,4.0090437890625,17.2392984375,3.4986437890625,17.1449984375,2.9587147890625C17.0642984375,2.4193407890625,16.5582984375,2.0499696890625,16.0199984375,2.1374649890625C9.1854884375,3.1558137890625,3.8296184374999998,8.5391237890625,2.8462156375,15.3787337890625C2.7726760375,15.9065337890625,3.1398784375,16.3945337890625,3.6674654374999998,16.4699337890625ZM16.3236984375,31.0949337890625C10.3454884375,30.2181337890625,5.647218437499999,25.5289337890625,4.7587184375,19.5524337890625C4.6783784375,19.0140337890625,4.1698184375,18.6479337890625,3.6337154375000003,18.7424337890625C3.0869744375,18.8108337890625,2.7109744375,19.3259337890625,2.8124656375,19.8674337890625C3.8377584375,26.6984337890625,9.217598437500001,32.0508337890625,16.0536984375,33.0412337890625L16.1886984375,33.0412337890625C16.6921984375,33.0351337890625,17.1068984375,32.6438337890625,17.1421984375,32.1415337890625C17.177398437500003,31.6392337890625,16.8214984375,31.1938337890625,16.3236984375,31.1174337890625L16.3236984375,31.0949337890625ZM32.8949984375,18.7199337890625C32.3588984375,18.6253337890625,31.8502984375,18.9915337890625,31.7699984375,19.5299337890625C30.9023984375,25.5108337890625,26.2247984375,30.2204337890625,20.2499984375,31.1287337890625C19.7069984375,31.2034337890625,19.3343984375,31.7138337890625,19.4286984375,32.2537337890625C19.5003984375,32.7280337890625,19.9052984375,33.0805337890625,20.3849984375,33.086233789062504L20.5199984375,33.086233789062504C27.3727984375,32.0753337890625,32.750798437499995,26.6883337890625,33.7499984375,19.8337337890625C33.8226984375,19.2942337890625,33.436198437499996,18.8008337890625,32.8949984375,18.7424337890625L32.8949984375,18.7199337890625ZM20.2499984375,4.0837137890625C26.2290984375,4.9711437890625,30.9220984375,9.668713789062501,31.8036984375,15.6487337890625C31.8702984375,16.1213337890625,32.2714984375,16.474733789062498,32.748698437499996,16.4812337890625L32.8949984375,16.4812337890625C33.4379984375,16.4065337890625,33.810598437500005,15.8961337890625,33.7161984375,15.3562337890625C32.697998437500004,8.527913789062499,27.3282984375,3.1719537890625,20.4974984375,2.1712149890625C19.9606984375,2.0902678890625,19.4588984375,2.4565967890625,19.3724984375,2.9924647890625C19.2998984375,3.5400037890625002,19.6995984375,4.0371237890625,20.2499984375,4.0837137890625ZM27.9561984375,17.5837337890625C27.9561984375,12.2528337890625,23.6345984375,7.9312137890625,18.3036984375,7.9312137890625C12.9727984375,7.9312137890625,8.651218437499999,12.2528337890625,8.651218437499999,17.5837337890625C8.651218437499999,22.9146337890625,12.9727984375,27.2362337890625,18.3036984375,27.2362337890625C23.6144984375,27.2177337890625,27.9151984375,22.9170337890625,27.9336984375,17.6062337890625L27.9561984375,17.5837337890625ZM18.3036984375,25.3012337890625C14.0322984375,25.3074337890625,10.5657984375,21.8476337890625,10.5637284375,17.5762337890625C10.5616584375,13.3048337890625,14.0247984375,9.8416537890625,18.2961984375,9.8437237890625C22.5675984375,9.845793789062501,26.0273984375,13.3123337890625,26.0211984375,17.5837337890625C26.0274984375,21.8609337890625,22.5584984375,25.3299337890625,18.281198437500002,25.3237337890625L18.3036984375,25.3012337890625Z\" fill=\"currentColor\" fill-opacity=\"1\"/></g><g><path d=\"M18.2816015625,13.74755859375C16.1504715625,13.74755859375,14.4228515625,15.47517859375,14.4228515625,17.60630859375C14.4228515625,19.73743859375,16.1504715625,21.46505859375,18.2816015625,21.46505859375C20.4127315625,21.46505859375,22.1403515625,19.73743859375,22.1403515625,17.60630859375C22.1341715625,15.47774859375,20.4101615625,13.75373703375,18.2816015625,13.74755859375ZM18.2816015625,19.53005859375C17.216061562500002,19.51145859375,16.3661415625,18.63478859375,16.3805615625,17.56917859375C16.3949715625,16.50357859375,17.2682915625,15.650218593750001,18.3339415625,15.66043859375C19.3996015625,15.67066859375,20.2563815625,16.54062859375,20.2503515625,17.60630859375C20.2506515625,18.68658859375,19.3615915625,19.555328593749998,18.2816015625,19.53005859375Z\" fill=\"currentColor\" fill-opacity=\"1\"/></g></g></svg>"
					}
						// {
					// 	title: "智慧城市为基础",
					// 	sub: "Based on smart cities",
					// 	description: "智能和5G、云计算、人工智能等新技术一起将人类带入万物互联的智能世界，是人工智能后的又一大重要能力。",
					// 	svg: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"36\" height=\"28.8\" viewBox=\"0 0 36 28.8\"><g fill='currentColor' transform=\"translate(-85.333 -170.666)\"><path class=\"a\" d=\"M114.266,172.466v3.6h5.609v21.6H108.428v-25.2h5.838m1.761-1.8h-9.36v28.8h14.969v-25.2h-5.609v-3.6Z\" transform=\"translate(-20.453)\"/><path class=\"a\" d=\"M436.353,343.094V360.7h-7.925v-17.61h7.925m1.761-1.761H426.667v21.132h11.447V341.333Z\" transform=\"translate(-326.783 -162.999)\"/><path class=\"a\" d=\"M665.736,257.806v5.417h4.4v16.25h-7.044V257.806h2.641M667.5,256h-6.164v25.278H671.9V261.417h-4.4Z\" transform=\"translate(-551.447 -81.812)\"/><path class=\"a\" d=\"M85.333,402.177h36v1.818h-36ZM91.633,384h4.5v1.818h-4.5Zm0,6.362h4.5v1.818h-4.5Zm0,6.362h4.5v1.818h-4.5Zm12.6-7.271h2.7v1.818h-2.7Zm0,5.453h2.7v1.818h-2.7Zm9.9-4.544h1.8v1.818h-1.8Zm0,5.453h1.8v1.818h-1.8Z\" transform=\"translate(0 -204.529)\"/></g></svg>"
					// },
					// {
					// 	title: "智能化自主决策",
					// 	sub: "Intelligent",
					// 	description: "智能数据能帮助设备对周围环境进行感知，获取精确的空间和时间信息，并帮助设备进行计算而进行自主决策。",
					// 	svg: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"36\" height=\"35.989\" viewBox=\"0 0 36 35.989\"><g fill='currentColor' transform=\"translate(-66.861 -66.998)\"><path class=\"a\" d=\"M570.013,349.848a2.265,2.265,0,1,0-2.263-2.265A2.267,2.267,0,0,0,570.013,349.848Z\" transform=\"translate(-480.657 -267.078)\"/><path class=\"a\" d=\"M202.832,71.494h-6.7V69.246A2.249,2.249,0,0,0,193.89,67h-4.524a2.25,2.25,0,0,0-2.244,2.248v2.248h-6.737a2.244,2.244,0,0,0-2.24,2.248v15.64a2.341,2.341,0,0,0,2.24,2.355h6.737v2.25h-6.7a2.246,2.246,0,0,0-2.24,2.248v4.507a2.245,2.245,0,0,0,2.24,2.246h22.368a2.245,2.245,0,0,0,2.24-2.246V96.235a2.246,2.246,0,0,0-2.24-2.248H196.13v-2.25h6.7a2.344,2.344,0,0,0,2.244-2.355V73.741A2.248,2.248,0,0,0,202.832,71.494Zm-13.466-2.246s0,0,0,0h4.515l0,0v2.246h-4.524V69.248Zm13.426,26.987v4.507H180.429s0,0,0,0v-4.5h6.7a2.247,2.247,0,0,0,2.244-2.248v-2.25h4.524v2.25a2.246,2.246,0,0,0,2.24,2.248Zm.039-22.493V89.487H180.385V73.741h22.447Z\" transform=\"translate(-106.75)\"/><path class=\"a\" d=\"M347.334,349.848a2.265,2.265,0,1,0-2.263-2.265A2.267,2.267,0,0,0,347.334,349.848Z\" transform=\"translate(-266.972 -267.078)\"/><path class=\"a\" d=\"M67.99,345.372a1.132,1.132,0,0,0-1.129,1.134v4.535a1.131,1.131,0,1,0,2.263,0v-4.535A1.133,1.133,0,0,0,67.99,345.372Z\" transform=\"translate(0 -267.137)\"/><path class=\"a\" d=\"M902.733,345.372a1.132,1.132,0,0,0-1.129,1.134v4.535a1.131,1.131,0,1,0,2.263,0v-4.535A1.133,1.133,0,0,0,902.733,345.372Z\" transform=\"translate(-801.005 -267.137)\"/></g></svg>"
					// },
					// {
					// 	title: "数据优化业务",
					// 	sub: "Data optimization",
					// 	description: "全业务节点数据记录；数据可视化，用数据驱动业务优化。",
					// 	svg: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"36\" height=\"36\" viewBox=\"0 0 36 36\"><path fill='currentColor' class=\"a\" d=\"M203.415,210.934a1.253,1.253,0,0,1-1.139-.684,1.851,1.851,0,0,0-3.19,0c-.456.456-.911.684-1.367.456a.837.837,0,0,1-.684-.228l-2.506-1.367a1.838,1.838,0,0,1-.684-2.051c0-.228.228-.456.228-.684a1.96,1.96,0,0,0-1.823-1.823h-.228a1.955,1.955,0,0,1-1.595-1.367,4.442,4.442,0,0,0,.228-1.823,6.309,6.309,0,0,1,.228-2.051,1.524,1.524,0,0,1,1.595-1.367h.228a1.96,1.96,0,0,0,1.823-1.823.837.837,0,0,0-.228-.684,1.838,1.838,0,0,1,.684-2.051l2.506-1.367c.228,0,.456-.228.684-.228a3.238,3.238,0,0,1,1.367.456,4.767,4.767,0,0,0,1.367.911c.456-.228,1.139-.456,1.367-.911a3.238,3.238,0,0,1,1.367-.456.837.837,0,0,1,.684.228l2.506,1.367a1.837,1.837,0,0,1,.684,2.051c0,.228-.228.456-.228.684a1.557,1.557,0,0,0,1.595,1.595h.456a1.955,1.955,0,0,1,1.367,1.595,5.663,5.663,0,0,1,.228,1.823,6.653,6.653,0,0,1-.456,2.051,1.47,1.47,0,0,1-1.367,1.367,1.96,1.96,0,0,0-1.823,1.823.837.837,0,0,0,.228.684,1.838,1.838,0,0,1-.684,2.051l-2.506,1.595c-.228.228-.456.228-.911.228Zm-2.734-4.1a4.048,4.048,0,0,1,2.278.911c.228.228.456.456.684.456l1.367-.684c0-.456-.228-.684-.228-1.139a3.978,3.978,0,0,1,3.418-4.1v-2.051a4.145,4.145,0,0,1-3.418-4.1,2.054,2.054,0,0,1,.228-1.139l-1.367-.684c-.228.228-.456.228-.684.456a3.3,3.3,0,0,1-4.557,0c-.228-.228-.456-.228-.684-.456l-1.367.684a9.867,9.867,0,0,1,.228,1.139,4.173,4.173,0,0,1-3.646,4.1V202.5a4.145,4.145,0,0,1,3.418,4.1,2.054,2.054,0,0,1-.228,1.139l1.367.684c.228-.228.456-.228.684-.456A4.154,4.154,0,0,1,200.681,206.833Zm-10.709,4.1a26.866,26.866,0,0,1-10.481-2.051c-2.962-1.367-4.557-2.962-4.557-5.013V182.909c0-4.329,6.835-7.975,15.038-7.975s15.038,3.646,15.038,7.975V190.2h-2.734v-2.734a19.821,19.821,0,0,1-12.3,3.418,19.821,19.821,0,0,1-12.3-3.418v3.19c0,2.051,4.329,3.646,10.253,4.1h.228v2.734h-.228a20.572,20.572,0,0,1-10.253-2.962v2.962c0,2.051,4.329,3.646,10.253,4.1h.228v2.734h-.228a20.572,20.572,0,0,1-10.253-2.962V204.1c0,2.278,5.7,4.1,12.3,4.1h.228l-.228,2.734Zm-12.3-27.8c0,2.734,5.7,5.241,12.3,5.241,6.835,0,12.3-2.278,12.3-5.241s-5.7-5.24-12.3-5.24S177.668,180.174,177.668,183.136Zm19.139,18.228a3.873,3.873,0,1,1,3.873,3.873A3.993,3.993,0,0,1,196.807,201.364Zm2.506,0A1.485,1.485,0,1,0,200.908,200C199.769,199.769,199.313,200.453,199.313,201.364Z\" transform=\"translate(-174.934 -174.934)\"/></svg>"
					// }
				],
			},
			banner,
			index: 0,
			options: [
				{
					label: '智慧水利',
					value: '智慧水利'
				},
				{
					label: '智慧矿山',
					value: '智慧矿山'
				},
				{
					label: '智慧港口',
					value: '智慧港口'
				},
				{
					label: '智慧交通',
					value: '智慧交通'
				},
				{
					label: '智慧城市',
					value: '智慧城市'
				}
			],
			form: {
				project: '',
				name: '',
				phone: '',
				company: ''
			}
		};
	},
	computed: {
		...mapGetters(["globalData"]),
		static() {
			return this.$store.getters.globalData.about;
		},
		block1() {
			return window.deepMerge(this.defines.block1, this.static.block1)
		},
		block2() {
			return window.deepMerge(this.defines.block2, this.static.block2)
		},
	},
	
	methods: {
		scrollTo(i) {
			const refs = [
				this.$refs.b1,
				this.$refs.b2,
				this.$refs.b3,
				this.$refs.b4,
				this.$refs.b5
			]
			const dom = refs.map((t) => {
				if (t instanceof HTMLElement) return t;
				return t.$el;
			});
			const target = dom[i];
			const top = target.offsetTop - 100;
			window.scrollTo({
				top,
				behavior: 'smooth'
			})
		},
		sendInfo() {
			this.$router.push({
				name: "get-plan",
				params: {
					name: this.form.name,
					mobile: this.form.phone,
					company: this.form.company,
					plan: this.options[this.index].value
				},
			});
		},
	}
};
</script>

<style scoped lang="scss">

.about {
	::v-deep(.now-button) {
		display: none
	}

	.link-card {
		display: flex;
		justify-content: space-between;
		align-items: center;

		.lc-item {
			display: flex;
			justify-content: center;
			align-items: center;
			gap: 16px;
			width: 200px;
			height: 98px;
			background: transparent;
			box-shadow: 3px 3px 8px 1px #E8E8E8;
			border-radius: 2px 2px 2px 2px;
			font-family: Source Han Sans CN, Source Han Sans CN;
			font-weight: 500;
			font-size: 24px;
			color: #333333;
			cursor: pointer;

			&:hover,
			&.checked {
				background: #4E99FD;
				color: white
			}
		}
	}

	.banner-title {
		color: #3384e8;
		font-size: 48px;
		font-weight: bold;
		margin-bottom: 64px;
		text-align: left;
		text-align: center;

		@media screen and (max-width: 767px) {
			text-align: center;
			font-size: 24px;
		}
	}

	.banner-subtitle {
		color: white;
		font-size: 24px;
		margin-bottom: 64px;
		text-align: left;
		line-height: 2;
		font-family: "Source Han Sans CN-Medium", serif;

		@media screen and (max-width: 767px) {
			text-align: center;
			font-size: 18px;
			white-space: normal;
			word-wrap: break-word;
		}
	}

	.team {
		padding-top: 80px;
		.team-content {
			display: flex;
    	justify-content: center;
			gap: 20px;
			.left {
				color: rgba($color: #fff, $alpha: 0.8);
				background: url(../asset/about/team-1.png) no-repeat center/cover;
				padding: 60px 25px 0px 25px;
				width: 460px;
				height: 760px;
				flex-shrink: 0;
				font-size: 20px;
				box-sizing: border-box;
				text-indent: 2em;
			}
			.right {
				display: grid;
				grid-template-columns: repeat(2, 1fr);
				gap: 20px;
				.item {
					width: 390px;
					height: 370px;
					box-sizing: border-box;
					display: flex;
					flex-direction: column;
					justify-content: flex-end;
					&:first-child {
						background: url(../asset/about/team-2.png) no-repeat center/cover;
					}
					&:nth-of-type(2) {
						background: url(../asset/about/team-3.png) no-repeat center/cover;
					}
					&:nth-of-type(3) {
						background: url(../asset/about/team-4.png) no-repeat center/cover;
					}
					&:last-child {
						background: url(../asset/about/team-5.png) no-repeat center/cover;
					}
					.label {
						background-color: rgba($color: #000000, $alpha: 0.6);
						color: #fff;
						font-size: 20px;
						padding: 22px 0;
						text-align: center;
					}
				}
			}
		}
	}
	.v-list {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 43px;

		.v-item {
			width: 400px;
			display: grid;
			padding: 40px 24px;
			justify-content: center;
			grid-template-rows: repeat(3, auto) 1fr;
			border-radius: 8px 8px 8px 8px;
			border: 1px solid rgba(51, 51, 51, 0.2);

			&:hover {
				background: linear-gradient(167deg, #68A9FF 0%, #4E99FD 100%);

				 .sp-icon {
					color: white !important;

					&:before {
						border: 1px solid rgb(255, 255, 255);
					}
				}

				.sp-tt,
				.sp-description {
					color: white;
				}

				.sp-sub {
					color: rgba(255, 255, 255, 0.6);
				}
			}

			.sp-icon {
				width: 100px;
				height: 100px;
				position: relative;
				margin: 0 auto;
				display: flex;
				justify-content: center;
				align-items: center;
				color: rgba(78, 153, 253, 1);

				&:before {
					content: '';
					width: #{sqrt(5000)}px;
					height: #{sqrt(5000)}px;
					position: absolute;
					transform: rotate(45deg);
					border: 1px solid rgba(51, 51, 51, 0.1);
				}
			}

			.sp-tt {
				font-family: Source Han Sans CN, Source Han Sans CN;
				font-weight: 500;
				font-size: 24px;
				color: #333333;
				text-align: center;
				margin-top: 16px;
			}

			.sp-sub {
				font-family: Source Han Sans CN, Source Han Sans CN;
				font-weight: 400;
				font-size: 18px;
				color: #999999;
				text-align: center;
				margin-top: 10px;
			}

			.sp-description {
				font-family: Source Han Sans CN, Source Han Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #666666;
				line-height: 32px;
				margin-top: 24px;
			}
		}
	}

	.bbg {
		background: url("@/asset/about/b3-bg.png") center no-repeat;
		background-size: cover;
	}

	.my-box {
		width: 1280px;
		height: 304px;
		background: linear-gradient(147deg, #F4EDE1 0%, #98B1C6 100%, #98B1C6 100%);
		border-radius: 0px 0px 0px 0px;
		margin-top: 110px;
		.my-list{
			width: 1200px;
			display: flex;
			align-items: center;
			margin: 0 auto;
			.my-item{
				margin-top: 40px;
			}
		}
	}

	.tips {
		width: 1280px;
		height: 382px;
		font-family: unset;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		line-height: 38px;
		text-align: left;
		// font-style: normal;
		// text-transform: none;
		margin-top: 24px;
		opacity: 0.8;
		// font-family:  serif;
		margin-bottom: 40px;
		*{
			font-family: none;
		}
	}

	.bt {
		// text-align: center;

		.title {
			font-family: YouSheBiaoTiHei, YouSheBiaoTiHei;
			font-weight: 800 !important;
			font-size: 36px;
			color: #FFFFFF;
		}

		.en {
			font-family: Source Han Sans CN, Source Han Sans CN;
			font-weight: 500;
			font-size: 24px;
			color: rgba(#FFFFFF, 0.4);
		}

		.sub {
			font-family: Source Han Sans CN, Source Han Sans CN;
			font-weight: 400;
			font-size: 24px;
			color: rgba(#FFFFFF, 0.6);
		}
	}

	.zig-card {
		display: flex;
		align-items: center;

		.word-context {
			width: 700px;
			flex-shrink: 0;
			height: 364px;
			box-sizing: border-box;
			background: #FFFFFF;
			padding: 60px;
			display: flex;
			justify-content: center;
			flex-direction: column;
			transform: translateX(-60px);

			box-shadow: 3px 5px 20px 1px rgba(202, 202, 202, 0.16);
			border-radius: 4px 4px 4px 4px;

			.wt {
				font-family: Source Han Sans CN, Source Han Sans CN;
				font-weight: bold;
				font-size: 24px;
				color: #4E99FD;
			}

			.word {
				margin-top: 40px;
				font-family: Source Han Sans CN, Source Han Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #666666;
				line-height: 32px;
				white-space: nowrap;
			}
		}
	}

	.s-list {
		display: flex;
		justify-content: space-between;

		.s-item {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			font-family: Source Han Sans CN, Source Han Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #333333;
			line-height: 36px;
			text-stroke: 1px rgba(0, 0, 0, 0);
			text-align: center;
			font-style: normal;
			text-transform: none;
			-webkit-text-stroke: 1px rgba(0, 0, 0, 0);

			.title {
				margin-top: 40px;
			}
		}
	}

	.b4 {
		background: url("@/asset/about/b4.png") center no-repeat;
		background-size: cover;
		height: 404px;
		position: relative;
		margin-top: 145px;

		&:before {
			content: '';
			position: absolute;
			bottom: 0;
			left: 0;
			transform: translateX(-85px);
			width: 699px;
			height: 549px;
			background: url("@/asset/about/b4-0.png") center no-repeat;
			background-size: cover;
		}

		.dot-list {
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translateY(-50%);
			display: flex;
			flex-direction: column;
			height: 180px;
			justify-content: space-between;

			.dl-item {
				font-family: Source Han Sans CN, Source Han Sans CN;
				font-weight: 500;
				font-size: 36px;
				color: #0865AA;
				position: relative;
				padding-left: 30px;

				&:before {
					content: '';
					width: 20px;
					height: 20px;
					position: absolute;
					display: block;
					left: 0;
					top: 50%;
					transform: translateY(-50%);
					border-radius: 50%;
					background: #0865AA;
				}
			}
		}
	}

	.block-info {
		background: #FFFFFF;
		box-shadow: 3px 5px 20px 1px #E0E0E0;
		box-sizing: border-box;
		padding: 60px;

		.title {
			font-family: Source Han Sans CN, Source Han Sans CN;
			font-weight: 500;
			font-size: 24px;
			color: #333333;
			line-height: 36px;
			text-stroke: 1px rgba(0, 0, 0, 0);
			font-style: normal;
			text-transform: none;
			-webkit-text-stroke: 1px rgba(0, 0, 0, 0);
		}

		.if-list {
			display: grid;
			grid-template-columns: repeat(3, 1fr);
			gap: 140px;
			margin-top: 40px;

			.if-item {
				display: flex;
				flex-direction: column;
				gap: 10px;

				.if-tt {
					font-family: Source Han Sans CN, Source Han Sans CN;
					font-size: 14px;
					color: rgba(51, 51, 51, 1)
				}

				.if-val {
					font-family: Source Han Sans CN, Source Han Sans CN;
					font-size: 24px;
					color: rgba(51, 51, 51, 1);
					line-height: 1.5;

					.sm {
						font-size: 16px;
					}
				}
			}
		}
	}

	.map-container {
		height: 392px;
		margin-top: 40px;
		background: url("@/asset/about/a-map.png") center no-repeat;
		background-size: cover;
	}

	.sub-container {
		display: flex;
		justify-content: space-between;

		select {
			height: 40px;
			padding: 10px;
			border-radius: 4px;
			background-color: #f2f2f2;
			font-size: 14px;
			color: #333333;
			appearance: none;
			-webkit-appearance: none;
			cursor: pointer;
		}

		select:hover {
			background-color: #e0e0e0;
		}

		select::-ms-expand {
			display: none;
		}

		select::after {
			content: '\25BC';
			position: absolute;
			top: 50%;
			right: 10px;
			transform: translateY(-50%);
			color: #999999;
			pointer-events: none;
		}
	}

	.n-i {
		width: 224px;
		height: 60px;
		position: relative;

		input {
			outline: none;
			border: 1px solid rgba(221, 221, 221, 1);
			width: 100%;
			height: 100%;
			padding-left: 24px;
			box-sizing: border-box;
		}

		&.required:before {
			content: '*';
			display: block;
			position: absolute;
			width: 10px;
			height: 10px;
			left: 12px;
			top: 50%;
			transform: translateY(calc(-50% - 6px));
			font-size: 24px;
			color: red;
		}
	}

	.n-btn {
		width: 224px;
		height: 60px;
		display: flex;
		justify-content: center;
		align-items: center;
		background: #4E99FD;
		border-radius: 2px 2px 2px 2px;
		font-family: Source Han Sans CN, Source Han Sans CN;
		font-weight: 500;
		font-size: 16px;
		color: #FFFFFF;
		cursor: pointer;

		span {
			display: block;
			width: 40px;
			text-align: justify;
			text-align-last: justify;
		}
	}
}
</style>
